import React, { useState, useEffect } from "react";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5"; // Assuming the download icon is from react-icons
import styles from "../commanstyles.module.css";

function DirectorsShareholdingTable({ isSubScribe, financialYear, data }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [isTableOneOpen, setIsTableOneOpen] = useState(true);
    const [
        selectedYearDirectorsShareholding,
        setSelectedDirectorsShareholding,
    ] = useState("");
    const rowsPerPage = 10;

    const toggleTableOne = () => {
        if (!isSubScribe) {
            alert("Please unlock to see the data.");
            return;
        }
        setIsTableOneOpen((prev) => !prev);
    };

    const getAvailableYears = () => {
        const years = Array.from(
            new Set(data.map((item) => item.financialYear))
        ).sort((a, b) => b - a);
        return years;
    };

    useEffect(() => {
        const years = getAvailableYears();
        if (years.length > 0) {
            setSelectedDirectorsShareholding(years[0]);
        }
    }, [data]);

    const filteredData = data.filter((item) =>
        selectedYearDirectorsShareholding
            ? item.financialYear == selectedYearDirectorsShareholding
            : true
    );

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const handleClick = (page) => {
        setCurrentPage(page);
    };

    const handlePrevious = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const handleNext = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const formattedFinancialYear = financialYear
        ? new Date(financialYear).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
          })
        : "Invalid Date";

    return (
        <div className={styles.table_subcontainer}>
            {!isSubScribe && (
                <button className={styles.Subscription_msg}>
                    <IoMdLock /> Subscription required to view data
                </button>
            )}

            {isSubScribe && (
                <div className={styles.highlet_header_content1}>
                    <p className={styles.minuse_icon} onClick={toggleTableOne}>
                        {isTableOneOpen ? (
                            <FaMinusSquare size={22} />
                        ) : (
                            <FaPlusSquare size={22} />
                        )}
                    </p>
                    <h3 className={styles.highlet_text}>
                        {/* DIRECTORS and KMP SHAREHOLDING -  31 Mar, {selectedYearDirectorsShareholding || "All Years"}
                         */}
                        DIRECTORS and KMP SHAREHOLDING
                        {filteredData.length > 0 &&
                            selectedYearDirectorsShareholding &&
                            ` - 31 Mar, ${selectedYearDirectorsShareholding}`}
                    </h3>
                    {/* Year selection dropdown */}
                    {filteredData.length > 0 && (
                        <div className={styles.yearSelectContainer}>
                            <select
                                // id="year-select"
                                value={selectedYearDirectorsShareholding}
                                onChange={(e) =>
                                    setSelectedDirectorsShareholding(
                                        e.target.value
                                    )
                                }>
                                {getAvailableYears().map((year) => (
                                    <option key={year} value={year}>
                                        {parseInt(year) - 1} - {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            )}

            {isTableOneOpen && isSubScribe && (
                <>
                    {/* Reference Documents Section */}
                    <span>
                        <div>
                            {filteredData &&
                                filteredData?.length > 0 &&
                                [filteredData[0]].map((item) => (
                                    <div
                                        key={item.Id}
                                        className={styles.referencedoc_main}>
                                        <div>
                                            <b>Reference Documents</b>
                                        </div>

                                        <div
                                            className={
                                                styles.referencedoc_container
                                            }>
                                            {item.refDoc ? (
                                                <>
                                                    <div>
                                                        {item.refDoc
                                                            ?.MaiinFileName && (
                                                            <a
                                                                href={
                                                                    item.refDoc
                                                                        ?.fileurl
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={
                                                                    styles.referencedoc_mainfilename
                                                                }>
                                                                {
                                                                    item.refDoc
                                                                        ?.MaiinFileName
                                                                }
                                                            </a>
                                                        )}
                                                        <ul
                                                            style={{
                                                                padding: 0,
                                                            }}>
                                                            {item.refDoc
                                                                ?.Attachments &&
                                                            item.refDoc
                                                                ?.Attachments
                                                                .length > 0 ? (
                                                                item.refDoc?.Attachments.map(
                                                                    (
                                                                        attachment,
                                                                        index
                                                                    ) => (
                                                                        <li
                                                                            key={
                                                                                index
                                                                            }
                                                                            className={
                                                                                styles.referencedoc_Attachments
                                                                            }>
                                                                            <IoDocumentTextOutline
                                                                                size={
                                                                                    16
                                                                                }
                                                                                style={{
                                                                                    marginRight:
                                                                                        "8px",
                                                                                    color: "#2961EF",
                                                                                }}
                                                                            />
                                                                            <a
                                                                                href={
                                                                                    attachment.fileurl
                                                                                }
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{
                                                                                    textDecoration:
                                                                                        "none",
                                                                                    color: "#2961EF",
                                                                                }}>
                                                                                {
                                                                                    attachment.Name
                                                                                }
                                                                            </a>
                                                                            <button
                                                                                onClick={() => {
                                                                                    const link =
                                                                                        document.createElement(
                                                                                            "a"
                                                                                        );
                                                                                    link.href =
                                                                                        attachment.fileurl;
                                                                                    link.download =
                                                                                        attachment.Name;
                                                                                    link.click();
                                                                                }}
                                                                                title="Download"
                                                                                style={{
                                                                                    background:
                                                                                        "none",
                                                                                    border: "none",
                                                                                    cursor: "pointer",
                                                                                    color: "#2961EF",
                                                                                    marginLeft:
                                                                                        "5px",
                                                                                    textDecoration:
                                                                                        "underline",
                                                                                }}>
                                                                                <FiDownload />
                                                                            </button>
                                                                        </li>
                                                                    )
                                                                )
                                                            ) : (
                                                                <span>
                                                                    No
                                                                    attachments
                                                                    available.
                                                                </span>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </>
                                            ) : (
                                                <span>
                                                    No documents available for
                                                    selected year
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </span>
                    <table className={styles.commantable}>
                        <thead>
                            <tr className={styles.tableHeaderRow}>
                                <th className={styles.tableHeader}>SNo.</th>
                                <th className={styles.tableHeader}>Name</th>
                                <th className={styles.tableHeader}>
                                    DIN / PAN
                                </th>
                                <th className={styles.tableHeader}>
                                    Designation
                                </th>
                                <th className={styles.tableHeader}>
                                    Number of equity share(s) held
                                </th>
                                <th className={styles.tableHeader}>
                                    (%) Shareholding{" "}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((row, index) => (
                                    <tr
                                        key={row.Id}
                                        className={styles.tableRow}>
                                        <td className={styles.tableCell}>
                                            {indexOfFirstRow + index + 1}.
                                        </td>
                                        <td className={styles.tableCell}>
                                            {row.name}
                                        </td>
                                        <td className={styles.tableCell}>
                                            {row.DIN}
                                        </td>
                                        <td className={styles.tableCell}>
                                            {row.designation}
                                        </td>
                                        <td className={styles.tableCell}>
                                            {row.shareholding}
                                        </td>
                                        <td className={styles.tableCell}>
                                            {row.shareholding_percentage}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className={styles.noDataRow} style={{textAlign:"center"}  }>
                                        No Directors  KMP shareholding data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className={styles.pagination}>
                        <button
                            onClick={handlePrevious}
                            disabled={currentPage === 1}>
                            &lt;
                        </button>
                        {[...Array(totalPages).keys()].map((num) => (
                            <button
                                key={num + 1}
                                onClick={() => handleClick(num + 1)}
                                className={
                                    currentPage === num + 1 ? styles.active : ""
                                }>
                                {num + 1}
                            </button>
                        ))}
                        <button
                            onClick={handleNext}
                            disabled={currentPage === totalPages}>
                            &gt;
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}

export default DirectorsShareholdingTable;
